import { Injectable } from '@angular/core';
import { HttpInternalService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class IntegrationService {  

  constructor(private _httpService: HttpInternalService) { }  
  
  getIntegrationData(url: string, organizationId: string, userId: string) {
    return this._httpService.getRequest(`${url + "?OrganisationId=" + organizationId + "&userId=" + userId}`);
  }

  // SD-1198: the merged app catalogue behind Settings -> Integrations.
  //
  // Replaces getIntegrationData('Organisation/OrganisationConfigurationGetData', ...), which read
  // only the legacy dbo.OrganisationsIntegrations catalogue. Automator apps were kept on the page
  // by hand-inserted rows there — which is why some cards render a broken image (their logo is
  // base64 in the other table) and why an app with a live credential could still say "Connect".
  //
  // It also makes no third-party call, so the page paints without waiting on Xero or Intuit.
  getIntegrationsCatalogue(organizationId: string, userId: string) {
    return this._httpService.getRequest<any>(
      'Organisation/GetIntegrationsCatalogue?organisationId=' + encodeURIComponent(organizationId)
      + '&userId=' + encodeURIComponent(userId || ''));
  }

  // SD-1198: confirm the accounting connections against the providers, after the page has painted.
  // The two checks run concurrently server-side and either timing out reports "unknown" rather
  // than "disconnected" — a provider outage is not the user being logged out.
  refreshConnectionStatus(organizationId: string, userId: string) {
    return this._httpService.postRequest<any>(
      'Organisation/RefreshConnectionStatus?organisationId=' + encodeURIComponent(organizationId)
      + '&userId=' + encodeURIComponent(userId || ''), {});
  }

  getIntegrationList() {
    return this._httpService.getRequest('Organisation/OrganisationIntegrationData');
  }

  getGmailAccountList(organizationId: string, userId: string) {
    return this._httpService.getRequest('Organisation/OrganisationConnectedEmail' + "?organisationId=" + organizationId + "&userId=" + userId);
  }
}
